module.exports = require('./helpers/bundle-url').getBundleURL('15MIF') + "card-amex.50e8c488.svg";